import { ApiEndpoint } from 'common/module/api/endpoint';
import { ApiEndpointServiceInterface } from 'common/service/api-endpoint/service.interface';

const service = new ApiEndpoint();

export function ApiEndpointService(): ApiEndpointServiceInterface {
  return service;
}
